import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";

// import "./plugins/firebase";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import vueTour from "./plugins/vue-tour";
import "./plugins/toast";
import "./assets/style/style.scss";
import i18n from "./plugins/i18n";
import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);
import vueAwesomeCountdown from "vue-awesome-countdown";
Vue.use(vueAwesomeCountdown, "vac");
import VueTheMask from "vue-the-mask";
Vue.use(VueTheMask);
import VueCookies from "vue-cookies";
Vue.use(VueCookies);
import formatDate from "@/filters/formatDate";
import VueMeta from "vue-meta";
Vue.use(VueMeta);
Vue.filter("formatDate", formatDate);

// Tell Vue to use the plugin
Vue.config.productionTip = false;
store.dispatch("ACTION_CHECK_IS_AUTH");
VueClipboard.config.autoSetContainer = true;

new Vue({
  router,
  store,
  vuetify,
  vueTour,
  i18n,
  render: h => h(App)
}).$mount("#app");
